/** Maximum number of displayed limits in table info, limit selection popup */
export const MAX_DISPLAYED_LIMITS = 4;
